<style>
textarea {
    width: 100%;
    min-height: 100px;
}

div {
    padding-top: 10px;
    padding-bottom: 10px;
}
</style>

<script>
export let reportItem;
export let hideWidget;

let reportDetails = ''

function submitReportItem() {
    reportItem(reportDetails)
    reportDetails = ''
}
</script>

<div>
    <textarea bind:value={reportDetails} placeholder="Please detail why you are reporting this item here..."></textarea><br>
    <button on:click={hideWidget}>Cancel</button>
    <button class="submit" on:click={submitReportItem}>Report Item</button>
</div>